export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/submitted.84ea034f.svg","height":116,"width":134,"blurWidth":0,"blurHeight":0};